// extracted by mini-css-extract-plugin
export default {"fade":"FadeOutOnLanguageChange_fade__FfTNG","out":"FadeOutOnLanguageChange_out__IxPDv"};